import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  wrap: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  tooltip: {
    '& .MuiTooltip-tooltip': {
      background: theme.background.b1,
      color: theme.primary.p2,
      borderRadius: theme.borderRadius.md,
      padding: 8,
      marginBottom: '0 !important',
      maxWidth: 375,
      border: `1px solid ${theme.secondary.s2}`,
    },
  },
  tooltipIcon: {
    fontSize: 16,
    color: theme.secondary.s3,
  },
}));

export default useStyles;
